"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var __jsx = _react["default"].createElement;
var ArrowMoreIcon = function ArrowMoreIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 11.4l-2.976-2.976.848-.848L22.85 12l-4.425 4.424-.848-.848 2.976-2.976H2v-1.2h18.552z"
  }));
};
ArrowMoreIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var RelatedStory = function RelatedStory(props) {
  var title = props.title,
    description = props.description,
    route = props.route,
    image = props.image;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  return __jsx(_Grid["default"], {
    cols: [4, null, 10, null]
  }, __jsx(_Box["default"], {
    sx: {
      gridColumn: ["span 2", null, "span 3", null]
    }
  }, __jsx(Link, {
    route: "article",
    params: {
      url: "article/" + route
    }
  }, __jsx(_LinkRaw["default"], {
    title: title
  }, __jsx(_Image["default"], {
    sx: {
      aspectRatio: 1,
      objectFit: "cover",
      width: "100%",
      cursor: "pointer"
    },
    image: image,
    overlay: true,
    sizes: "(max-width: 720px) and (min-width: 495px) 420px, 210px"
  })))), __jsx(_Box["default"], {
    sx: {
      color: "main",
      gridColumn: ["span 2", null, "span 5", null]
    }
  }, __jsx(_Box["default"], {
    as: "h5",
    sx: {
      font: "heading3",
      py: "s5"
    }
  }, title), __jsx(_Box["default"], {
    as: "p",
    sx: {
      mb: "s7"
    }
  }, description), __jsx(Link, {
    route: "article",
    params: {
      url: "article/" + route
    }
  }, __jsx(_LinkRaw["default"], {
    title: title,
    sx: {
      cursor: "pointer"
    }
  }, __jsx(ArrowMoreIcon, null)))));
};
var _default = RelatedStory;
exports["default"] = _default;